import { render, staticRenderFns } from "./OperationRegistry.vue?vue&type=template&id=25236a11&"
import script from "./OperationRegistry.vue?vue&type=script&lang=js&"
export * from "./OperationRegistry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports